import { createContext } from 'react';
import { DEFAULT_WARBOX_CONVERSATION_CONTEXT } from './constants/defaultContext';

export const WarboxConversationContext = createContext(
    DEFAULT_WARBOX_CONVERSATION_CONTEXT
);
